var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9568 4.35778L26.2262 0.651164L40 14.1753L26.3787 27.5993L13.0623 14.7263V17.1807L10.521 17.0805V11.0698V10.5689H16.925L16.8742 12.7728V13.1234L14.7903 13.0733L20.6861 18.7335L24.9555 14.1252L14.2313 3.70662L3.55781 14.1252L14.2821 24.5939L16.8234 22.2397L18.5006 23.8426L14.7395 27.5993L14.3329 28L0 14.025L14.2821 0L29.5299 15.127L26.4295 15.0268L26.3787 17.0304L32.7319 17.0805V11.0698H30.7497L30.6989 13.3739L21.9568 4.35778Z",
    fill: "#5260FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/Cw.e71fd255ed7de88ed0d3f2a2f0125cc7.svg";
export { ForwardRef as ReactComponent };